/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BodyProtocolStateFromJSON, BodyProtocolStateToJSON, DamageDetailDtoFromJSON, DamageDetailDtoToJSON, FileDtoFromJSON, FileDtoToJSON, InteriorProtocolStateFromJSON, InteriorProtocolStateToJSON, } from './';
export function CarConditionDtoFromJSON(json) {
    return CarConditionDtoFromJSONTyped(json, false);
}
export function CarConditionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasDamage': !exists(json, 'hasDamage') ? undefined : json['hasDamage'],
        'bodyState': !exists(json, 'bodyState') ? undefined : BodyProtocolStateFromJSON(json['bodyState']),
        'interiorState': !exists(json, 'interiorState') ? undefined : InteriorProtocolStateFromJSON(json['interiorState']),
        'damagesMarkedPhotos': !exists(json, 'damagesMarkedPhotos') ? undefined : (json['damagesMarkedPhotos'] === null ? null : json['damagesMarkedPhotos'].map(FileDtoFromJSON)),
        'damagesDetails': !exists(json, 'damagesDetails') ? undefined : (json['damagesDetails'] === null ? null : json['damagesDetails'].map(DamageDetailDtoFromJSON)),
    };
}
export function CarConditionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasDamage': value.hasDamage,
        'bodyState': BodyProtocolStateToJSON(value.bodyState),
        'interiorState': InteriorProtocolStateToJSON(value.interiorState),
        'damagesMarkedPhotos': value.damagesMarkedPhotos === undefined ? undefined : (value.damagesMarkedPhotos === null ? null : value.damagesMarkedPhotos.map(FileDtoToJSON)),
        'damagesDetails': value.damagesDetails === undefined ? undefined : (value.damagesDetails === null ? null : value.damagesDetails.map(DamageDetailDtoToJSON)),
    };
}
